import { Link } from "react-router-dom";
function Footer() {
  return (
    <>
    <footer className="footer-wrapper footer-default footer-layout3">
      <div className="widget-area">
        <div className="container">
          <div className="row">
            <div className="col-lg-4">
              <div className="footer-all-widget-item">
                <div className="widget footer-widget">
                  <div className="th-widget-about">
                    <div className="about-logo">
                      <Link to="/">
                        <img src="/assets/img/logo-white.webp" width="250px" style={{ "marginBottom": "15px" }} alt="Piller-html" />
                      </Link>
                    </div>
                    <div className="footer-info-wrap">
                      <div className="footer-info">
                        <i className="fas fa-location-dot" />
                        <p className="info-box_link">
                          <span>
                            P.O. Box 9638 Office 113, MSM 1 Building
                            <br />
                            127 22D Street, Al Safa 1, Dubai, U.A.E.
                          </span>
                        </p>
                      </div>
                      <div className="footer-info">
                        <i className="fas fa-envelope" />
                        <p className="info-box_link">
                          <a href="mailto:info@bluewaterdubai.com">
                            info@bluewaterdubai.com
                          </a>
                        </p>
                      </div>
                      <div className="footer-info">
                        <i className="fas fa-phone" />
                        <p className="info-box_link">
                          <a href="tel:+971 4 4514747">
                            +971 4 4514747
                          </a>
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-lg-2">
              <div className="footer-item">
                <div className="widget widget_nav_menu footer-widget">
                  <h3 className="widget_title">
                    Properties
                  </h3>
                  <div className="menu-all-pages-container">
                    <ul className="menu">
                      <li>
                        <Link to="/properties/residential">
                          Residential
                        </Link>
                      </li>
                      <li>
                        <Link to="/properties/commercial">
                          Commercial
                        </Link>
                      </li>
                      <li>
                        <Link to="/developers">
                          Developers
                        </Link>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-lg-3">
              <div className="footer-item">
                <div className="widget widget_nav_menu footer-widget">
                  <h3 className="widget_title">
                    Links
                  </h3>
                  <div className="menu-all-pages-container">
                    <ul className="menu">
                      <li>
                        <Link to="/international">
                          International
                        </Link>
                      </li>
                      <li>
                        <Link to="/developers">
                          Developers
                        </Link>
                      </li>
                      <li>
                        <Link to="/list-your-property">
                          List Your Property
                        </Link>
                      </li>
                      <li>
                        <Link to="/about-us">
                          About Us
                        </Link>
                      </li>
                      <li>
                        <Link to="/blog">
                          Insights
                        </Link>
                      </li>
                      <li>
                        <Link to="/contact-us">
                          Contact Us
                        </Link>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-lg-3">
              <div className="footer-item">
                <div className="widget widget_nav_menu footer-widget">
                  <h3 className="widget_title">
                    Services
                  </h3>
                  <div className="menu-all-pages-container">
                    <ul className="menu">
                      <li>
                        <Link to="/buying">
                          Buying
                        </Link>
                      </li>
                      <li>
                        <Link to="/selling">
                          Selling
                        </Link>
                      </li>
                      <li>
                        <Link to="/leasing">
                          Leasing
                        </Link>
                      </li>
                      <li>
                        <Link to="/portfolio-management">
                          Portfolio Management
                        </Link>
                      </li>
                      <li>
                        <Link to="/property-management">
                          Property Management &amp; Maintenance
                        </Link>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="copyright-wrap">
        <div className="container">
          <div className="row   ">
            <div className="col-lg-7">
              <p className="copyright-text">
              Copyright 2025 Blue Water Real Estate Broker LLC . All Rights Reserved.
              </p>
            </div>
            <div className="col-lg-5">
              <div className="footer-default-copy-right">
                <p>
                  Social Media:
                </p>
                <div className="th-social">
                  <a href="https://www.facebook.com/">
                    <i className="fab fa-facebook-f" />
                  </a>
                  <a href="https://www.twitter.com/">
                    <i className="fab fa-twitter" />
                  </a>
                  <a href="https://www.linkedin.com/">
                    <i className="fab fa-linkedin-in" />
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>
    <a target="_blank" rel="noreferrer" href={"https://api.whatsapp.com/send?phone=971507455838&text=Hi, I'd like to speak with a real estate consultant. Please contact me at your earliest convenience."} className="whatsapp-button">
      <svg fill="#ffffff" height="25px" width="25px" version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xlink="http://www.w3.org/1999/xlink" viewBox="0 0 308 308" space="preserve" stroke="#ffffff" strokeWidth="0.0030800000000000003">
        <g id="SVGRepo_bgCarrier" strokeWidth="0" />
        <g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round" />
        <g id="SVGRepo_iconCarrier">
          <g id="XMLID_468_">
            <path id="XMLID_469_" d="M227.904,176.981c-0.6-0.288-23.054-11.345-27.044-12.781c-1.629-0.585-3.374-1.156-5.23-1.156 c-3.032,0-5.579,1.511-7.563,4.479c-2.243,3.334-9.033,11.271-11.131,13.642c-0.274,0.313-0.648,0.687-0.872,0.687 c-0.201,0-3.676-1.431-4.728-1.888c-24.087-10.463-42.37-35.624-44.877-39.867c-0.358-0.61-0.373-0.887-0.376-0.887 c0.088-0.323,0.898-1.135,1.316-1.554c1.223-1.21,2.548-2.805,3.83-4.348c0.607-0.731,1.215-1.463,1.812-2.153 c1.86-2.164,2.688-3.844,3.648-5.79l0.503-1.011c2.344-4.657,0.342-8.587-0.305-9.856c-0.531-1.062-10.012-23.944-11.02-26.348 c-2.424-5.801-5.627-8.502-10.078-8.502c-0.413,0,0,0-1.732,0.073c-2.109,0.089-13.594,1.601-18.672,4.802 c-5.385,3.395-14.495,14.217-14.495,33.249c0,17.129,10.87,33.302,15.537,39.453c0.116,0.155,0.329,0.47,0.638,0.922 c17.873,26.102,40.154,45.446,62.741,54.469c21.745,8.686,32.042,9.69,37.896,9.69c0.001,0,0.001,0,0.001,0 c2.46,0,4.429-0.193,6.166-0.364l1.102-0.105c7.512-0.666,24.02-9.22,27.775-19.655c2.958-8.219,3.738-17.199,1.77-20.458 C233.168,179.508,230.845,178.393,227.904,176.981z" />
            <path id="XMLID_470_" d="M156.734,0C73.318,0,5.454,67.354,5.454,150.143c0,26.777,7.166,52.988,20.741,75.928L0.212,302.716 c-0.484,1.429-0.124,3.009,0.933,4.085C1.908,307.58,2.943,308,4,308c0.405,0,0.813-0.061,1.211-0.188l79.92-25.396 c21.87,11.685,46.588,17.853,71.604,17.853C240.143,300.27,308,232.923,308,150.143C308,67.354,240.143,0,156.734,0z M156.734,268.994c-23.539,0-46.338-6.797-65.936-19.657c-0.659-0.433-1.424-0.655-2.194-0.655c-0.407,0-0.815,0.062-1.212,0.188 l-40.035,12.726l12.924-38.129c0.418-1.234,0.209-2.595-0.561-3.647c-14.924-20.392-22.813-44.485-22.813-69.677 c0-65.543,53.754-118.867,119.826-118.867c66.064,0,119.812,53.324,119.812,118.867 C276.546,215.678,222.799,268.994,156.734,268.994z" />
          </g>
        </g>
      </svg>
    </a>
    <a target="_blank" rel="noreferrer" href="tel:+" className="call-button">
      <svg fill="#000000" width="33px" height="33px" viewBox="0 0 24 24" id="call" data-name="Flat Color" xmlns="http://www.w3.org/2000/svg" className="icon flat-color">
        <g id="SVGRepo_bgCarrier" strokeWidth="0" />
        <g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round" />
        <g id="SVGRepo_iconCarrier">
          <path id="secondary" d="M17,13a1,1,0,0,1-1-1,4,4,0,0,0-4-4,1,1,0,0,1,0-2,6,6,0,0,1,6,6A1,1,0,0,1,17,13Zm4.93.12A8.32,8.32,0,0,0,22,12,10,10,0,0,0,12,2a8.32,8.32,0,0,0-1.12.07,1,1,0,1,0,.24,2A8.49,8.49,0,0,1,12,4a8,8,0,0,1,8,8,8.49,8.49,0,0,1-.05.88A1,1,0,0,0,20.82,14h.12A1,1,0,0,0,21.93,13.12Z" style={{ "fill": "#ffffff" }} />
          <path id="primary" d="M18.18,17.53a3,3,0,0,0-1.5-1.89c-.33-.17-.66-.36-1-.55a3,3,0,0,0-4,.79l-1.26,1.8a18.41,18.41,0,0,1-2.21-1.9,18.41,18.41,0,0,1-1.9-2.21l1.8-1.26a3,3,0,0,0,.79-4c-.19-.3-.38-.63-.55-1a3,3,0,0,0-4.29-1.1l-1,.62A2.15,2.15,0,0,0,2.06,9.21a14.48,14.48,0,0,0,2,4.63h0a19.15,19.15,0,0,0,2.71,3.33,19.15,19.15,0,0,0,3.33,2.71h0a14.48,14.48,0,0,0,4.63,2,2.29,2.29,0,0,0,.51.06,2.21,2.21,0,0,0,1.86-1.12l.62-.95A3,3,0,0,0,18.18,17.53Z" style={{ "fill": "#ffffff" }} />
        </g>
      </svg>
    </a>
    <div className="scroll-top">
      <svg className="progress-circle svg-content" width="100%" height="100%" viewBox="-1 -1 102 102">
        <path d="M50,1 a49,49 0 0,1 0,98 a49,49 0 0,1 0,-98" style={{ "transition": "stroke-dashoffset 10ms linear 0s", "strokeDasharray": "307.919, 307.919", "strokeDashoffset": "307.919" }} />
      </svg>
    </div>
    </>
  );
}

export default Footer;
